<template>
  <main class="app-content global-report">
    <div style="padding-top:1px;">
      <div class="orders dashboard order-media">
        <div class="row">
          <div class="col-12 col-md-12 col-lg-7 filter-elements">
            <div class="col-12 col-md-4 pb-2 pr-2">
              <client-list-dropdown
                :value="selectedClient"
                @on-client-selected="handleClientSelected"
                @on-client-removed="handleClientRemoved"
              />
            </div>

            <div class="col-12 col-md-4 pb-2 pr-2">
              <agency-list-dropdown
                :client-ids="agenciesDropdownFilter"
                :value="selectedAgencies"
                :multiple="true"
                @on-agency-selected="handleAgencySelected"
                @on-agency-removed="handleAgencyRemoved"
                :disabled="noClientSelected"
              />
            </div>

            <div class="col-12 col-md-4 pb-2 pr-2">
              <order-status-dropdown
                :value="selectedStatuses"
                :multiple="true"
                @on-order-status-selected="handleStatusSelected"
                @on-order-status-removed="handleStatusRemoved"
                :disabled="noClientSelected"
              />
            </div>

            <div class="col-12 col-md-4 pb-2 pr-2">
              <order-type-dropdown
                :value="selectedOrderTypes"
                :multiple="true"
                @on-order-type-selected="handleOrderTypeSelected"
                @on-order-type-removed="handleOrderTypeRemoved"
                :disabled="noClientSelected"
              />
            </div>

            <div class="col-12 col-md-4 pb-2 pr-2">
              <div class="date-time-picker-container inline">
                <DateTimePicker
                  color="#13a3eb"
                  class="mr-sm-2 test"
                  noLabel
                  formatted="DD MMM YYYY"
                  format="YYYY-MM-DD"
                  v-model="selectedDates"
                  autoClose
                  input-size="sm"
                  range
                  noClearButton
                  noButton
                  :no-value-to-custom-elem="false"
                  :max-date="dateConfig.max"
                  only-date
                  :disabled="noClientSelected"
                >
                </DateTimePicker>
                <div
                  class="c__info"
                  style="position: absolute; top: 10px; right: 20px;"
                >
                  <div class="c__tooltip_container">
                    <icon-info></icon-info>
                    <div class="c__tooltip">
                      You can select a maximum date range of 12 months for
                      individual clients, and 1 month for all clients.
                    </div>
                  </div>
                </div>
                <p
                  style="margin-bottom: 0px; font-size: 12px; color: red;"
                  v-if="dateConfig.error"
                >
                  Invalid date range
                </p>
              </div>
            </div>
          </div>
          <div
            class="col-12 col-md-12 col-lg-5 flex-column filter-buttons align-items-end"
          >
            <div>
              <button
                @click="getStats"
                class="btn btn-primary mr-3 mb-3"
                :disabled="
                  noClientSelected ||
                    dateConfig.error ||
                    !selectedDates.start ||
                    !selectedDates.end
                "
              >
                Display Report
              </button>
            </div>
            <div v-if="$isAllowed('exportCSV')">
              <button
                type="button"
                @click="downloadCsv"
                class="btn btn-quaternary"
                style="float:right; margin-right:10px!important"
                :disabled="noClientSelected || loadingStates.exportFilterButton"
              >
                Export CSV w/ Filters
              </button>
            </div>
          </div>
        </div>
        <div class="row">
          <div class="col-12 mt-4">
            <campaign-stat-section-heading
              title="Campaign Overview"
              description="Total number of completed campaigns"
              :loading="api[AGENCY_API] ? api[AGENCY_API].loading : false"
            >
            </campaign-stat-section-heading>
            <div class="global-report-campaign-stats-section" v-if="agencies">
              <stat-item-card
                v-for="agency in agencies"
                :key="agency.id"
                :value="agency.campaignCount"
                :label="agency.displayName || agency.title"
              >
              </stat-item-card>
            </div>
          </div>
          <div class="col-12 mt-4">
            <campaign-stat-section-heading
              title="Package Overview"
              description="Top performing and booked packages, based on campaigns purchased"
              :loading="api[PACKAGE_API] ? api[PACKAGE_API].loading : false"
            >
            </campaign-stat-section-heading>
            <div class="global-report-campaign-stats-section" v-if="packages">
              <stat-item-card
                v-for="packageItem in packages"
                :key="packageItem.id"
                :value="packageItem.campaignCount"
                :label="packageItem.title"
              ></stat-item-card>
            </div>
          </div>
          <div class="col-12 mt-5">
            <awareness-stats-section
              :adImpressions="adImpressions"
              :loading="api[STAT_API] ? api[STAT_API].loading : false"
            ></awareness-stats-section>

            <interest-and-engagement-stats-section
              :adClicks="adClicks"
              :ctr="socialCtr"
              :socialAdEngagement="socialEngagement"
              :loading="api[STAT_API] ? api[STAT_API].loading : false"
            ></interest-and-engagement-stats-section>

            <interest-indicators-section
              :soiViews="soiView"
              :imageViews="imageView"
              :videoViews="videoView"
              :websiteLiveChat="websiteLiveChat"
              :floorplanViews="floorplanView"
              :inspectionAuctionLocationViews="inspectionAuctionLocationViews"
              :loading="api[STAT_API] ? api[STAT_API].loading : false"
            ></interest-indicators-section>

            <enquiry-section
              :enquiryViaSocial="enquiryViaSocial"
              :enquiryViaForm="enquiryViaForm"
              :enquiryViaPhone="enquiryViaPhone"
              :enquiryViaEmail="enquiryViaEmail"
              :loading="api[STAT_API] ? api[STAT_API].loading : false"
            ></enquiry-section>
            <app-modal-progress-bar
              v-if="showExportModal"
              :progress="exportProgress"
              :label="exportModalLabel"
              :state="exportModalState"
            ></app-modal-progress-bar>
          </div>
        </div>
      </div>
    </div>
  </main>
</template>

<script>
import DateTimePicker from 'vue-ctk-date-time-picker';
import ClientPerimeters from '../../configs/Perimeters/clients';
import GlobalReportPerimeters from '../../configs/Perimeters/globalReport';
import {OrderDropdownFilterSelectedHelper} from '../../helpers/OrderDropdownFilterSelectedHelper';
import ClientListDropdown, {
  ClientListAllOption,
} from '../Clients/ClientListDropdown.vue';
import AgencyListDropdown, {
  AgencyListAllOption,
} from '../Agencies/AgencyListDropdown.vue';
import OrderStatusDropdown, {
  OrderStatusListAllOption,
} from '../Orders/OrderStatusDropdown.vue';
import OrderTypeDropdown, {
  OrderTypeAllOption,
} from '../Orders/OrderTypeDropdown.vue';
import {FilterBuilder} from '../../helpers/FilterBuilder';
import Navigation from '../../configs/Perimeters/navigation.js';
import {StringToCapitalizedCase} from '../../helpers/StringToCapitalizedCase.js';
import GlobalReportServiceV2 from '../../services/V2/GlobalReportServiceV2.js';
import CampaignStatSectionHeading from '../CampaignStats/CampaignStatSectionHeading';
import StatItemCard from '../CampaignStats/StatItemCard';
import AwarenessStatsSection from '../CampaignStats/AwarenessStatsSection';
import InterestAndEngagementStatsSection from '../CampaignStats/InterestAndEngagementStatsSection';
import InterestIndicatorsSection from '../CampaignStats/InterestIndicatorsSection';
import EnquirySection from '../CampaignStats/EnquirySection';
import formatNumber from '../../filters/formatNumber.js';
import {parse, format, differenceInDays} from 'date-fns';
import IconInfo from '../../assets/icons/icon-info';
import ApiCallMixin from '../../mixins/ApiCallMixin.js';
import AppModalProgressBar from '../AppComponents/Loaders/AppModalProgressBar.vue';

const currentDate = new Date();
const currentYear = new Date().getFullYear();
const currentMonth = new Date().getMonth();

export default {
  perimeters: [ClientPerimeters, GlobalReportPerimeters],
  mixins: [ApiCallMixin],
  components: {
    DateTimePicker,
    ClientListDropdown,
    AgencyListDropdown,
    OrderStatusDropdown,
    OrderTypeDropdown,
    CampaignStatSectionHeading,
    StatItemCard,
    AwarenessStatsSection,
    InterestAndEngagementStatsSection,
    InterestIndicatorsSection,
    EnquirySection,
    IconInfo,
    AppModalProgressBar,
  },
  data() {
    return {
      /** NEW DATA START */
      selectedClient: null,
      selectedAgencies: [],
      selectedStatuses: [],
      selectedOrderTypes: [],
      selectedDates: {
        start: null,
        end: null,
      },
      filterBuilder: new FilterBuilder(),
      client: null,
      clientId: null,
      loadingStates: {
        exportAllButton: false,
        exportFilterButton: false,
      },
      dateConfig: {
        maxDuration: 31,
        max: format(new Date(), 'YYYY-MM-DD'),
        error: false,
      },
      AGENCY_API: 'agency-api',
      PACKAGE_API: 'package-api',
      STAT_API: 'stat-api',
      showExportModal: false,
      exportProgress: 0,
      exportModalState: 'loading',
      exportModalLabel: 'Exporting CSV...',
    };
  },
  watch: {
    selectedClient: {
      handler: function(value) {
        this.validateDateRange();
      },
    },
    selectedDates: {
      handler: function(value) {
        this.validateDateRange();
      },
    },
    watchedFilterBuilderValues: {
      handler: function(value) {
        // Clone incoming object
        const filters = Object.assign({}, value);
        const keys = Object.keys(filters);

        keys.forEach((key) => {
          if (Array.isArray(filters[key])) {
            let filteredArray = filters[key].filter((val) => val); // Remove empty values
            if (filteredArray.length === 0) {
              this.filterBuilder.removeFilter(key);
            } else {
              this.filterBuilder.updateFilter(key, filteredArray);
            }
          } else {
            if (!filters[key]) {
              this.filterBuilder.removeFilter(key);
            } else {
              this.filterBuilder.updateFilter(key, filters[key]);
            }
          }
        });
      },
    },
  },
  methods: {
    validateDateRange() {
      if (!this.selectedDates.start || !this.selectedDates.end) return;

      const start = parse(this.selectedDates.start);
      const end = parse(this.selectedDates.end);
      const diff = differenceInDays(end, start);

      let error = false;

      if (this.selectedClient.id === 0) {
        if (diff > 30) {
          error = true;
        }
      } else if (typeof this.selectedClient.id === 'string') {
        if (diff > 365) {
          error = true;
        }
      }

      this.dateConfig.error = error;
    },
    clearFilters() {
      this.selectedClient = null;
      this.selectedAgencies = [];
      this.selectedStatuses = [];
      this.selectedOrderTypes = [];
      this.selectedDates = {
        start: null,
        end: null,
      };
      this.searchText = '';
    },
    handleClientSelected(value) {
      this.selectedClient = value;
      // Set selected agencies to only agencies under the selected client.
      this.selectedAgencies = [];
    },
    handleClientRemoved(value) {
      this.clearFilters();
    },
    handleAgencySelected(value) {
      this.selectedAgencies = OrderDropdownFilterSelectedHelper(
        this.selectedAgencies,
        value,
        AgencyListAllOption
      );
    },
    handleAgencyRemoved(value) {
      this.selectedAgencies = this.selectedAgencies.filter(
        (agency) => agency.id !== value.id
      );
    },
    handleStatusSelected(value) {
      this.selectedStatuses = OrderDropdownFilterSelectedHelper(
        this.selectedStatuses,
        value,
        OrderStatusListAllOption
      );
    },
    handleStatusRemoved(value) {
      this.selectedStatuses = this.selectedStatuses.filter(
        (status) => status.id !== value.id
      );
    },
    handleInvoiceSelected(value) {
      this.selectedInvoice = value;
    },
    handleInvoiceRemoved() {
      this.selectedInvoice = null;
    },
    handleOrderTypeSelected(value) {
      this.selectedOrderTypes = OrderDropdownFilterSelectedHelper(
        this.selectedOrderTypes,
        value,
        OrderTypeAllOption
      );
    },
    handleOrderTypeRemoved(value) {
      this.selectedOrderTypes = this.selectedOrderTypes.filter(
        (type) => type.id !== value.id
      );
    },
    handlePackageSelected(value) {
      this.selectedPackages = OrderDropdownFilterSelectedHelper(
        this.selectedPackages,
        value,
        PackageListAllOption
      );
    },
    handlePackageRemoved(value) {
      this.selectedPackages = this.selectedPackages.filter(
        (packageData) => packageData.id !== value.id
      );
    },
    async downloadCsv() {
      this.exportModalLabel = 'Exporting PDF Report...';
      this.loadingStates.exportFilterButton = true;

      this.showExportModal = true;
      this.exportProgress = 0;
      this.exportModalState = 'loading';

      let interval = setInterval(() => {
        if (this.exportProgress < 90) {
          this.exportProgress = this.exportProgress + 1;
        }
      }, 250);

      var today = new Date();
      var date =
        today.getFullYear() +
        '-' +
        (today.getMonth() + 1) +
        '-' +
        today.getDate();
      const response = await GlobalReportServiceV2.exportCsv(
        this.filterBuilder.get()
      );

      if (response.data.size > 0) {
        let url = window.URL.createObjectURL(new Blob([response.data]));
        let link = document.createElement('a');
        link.href = url;
        link.setAttribute('download', `Campaign Report ${date}.csv`);
        document.body.appendChild(link);
        link.click();
        this.exportModalLabel = 'CSV Export Successful!';
      }

      this.loadingStates.exportFilterButton = false;

      clearInterval(interval);
      this.exportProgress = 100;
      setTimeout(() => {
        this.showExportModal = false;
      }, 3000);
    },
    async downloadAllClientCsv() {
      this.loadingStates.exportFilterButton = true;

      this.showExportModal = true;
      this.exportProgress = 0;
      this.exportModalState = 'loading';

      let interval = setInterval(() => {
        if (this.exportProgress < 90) {
          this.exportProgress = this.exportProgress + 1;
        }
      }, 250);

      var today = new Date();
      var date =
        today.getFullYear() +
        '-' +
        (today.getMonth() + 1) +
        '-' +
        today.getDate();
      const response = await GlobalReportServiceV2.exportCsv();

      if (response.data.size > 0) {
        let url = window.URL.createObjectURL(new Blob([response.data]));
        let link = document.createElement('a');
        link.href = url;
        link.setAttribute('download', `Campaign Report ${date}.csv`);
        document.body.appendChild(link);
        link.click();
        this.exportModalLabel = 'CSV Export Successful!';
      }

      this.loadingStates.exportFilterButton = false;

      clearInterval(interval);
      this.exportProgress = 100;
      setTimeout(() => {
        this.showExportModal = false;
      }, 3000);
    },
    async getStats() {
      try {
        await this.request(
          this.AGENCY_API,
          GlobalReportServiceV2.getPerAgency,
          this.filterBuilder.get()
        );
        await this.request(
          this.PACKAGE_API,
          GlobalReportServiceV2.getPerPackage,
          this.filterBuilder.get()
        );
        await this.request(
          this.STAT_API,
          GlobalReportServiceV2.getStats,
          this.filterBuilder.get()
        );
      } catch (error) {}
    },
    handlePreselectedClient() {
      const isUserAdmin =
        Navigation.isClientAdmin() || Navigation.isAgencyAdmin();

      if (isUserAdmin === false) return;

      const user = this.$store.getters.getUser;

      const formattedClientName = StringToCapitalizedCase(user.client);

      this.selectedClient = {
        id: user.clientId,
        title: formattedClientName,
      };
    },
  },
  computed: {
    agencies() {
      if (!this.api[this.AGENCY_API]) return [];
      if (!this.api[this.AGENCY_API].response) return [];
      if (!this.api[this.AGENCY_API].response.data) return [];
      if (!this.api[this.AGENCY_API].response.data.data) return [];

      return this.api[this.AGENCY_API].response.data.data;
    },
    packages() {
      if (!this.api[this.PACKAGE_API]) return [];
      if (!this.api[this.PACKAGE_API].response) return [];
      if (!this.api[this.PACKAGE_API].response.data) return [];
      if (!this.api[this.PACKAGE_API].response.data.data) return [];

      return this.api[this.PACKAGE_API].response.data.data;
    },
    stats() {
      if (!this.api[this.STAT_API]) return [];
      if (!this.api[this.STAT_API].response) return [];
      if (!this.api[this.STAT_API].response.data) return [];
      if (!this.api[this.STAT_API].response.data.data) return [];

      return this.api[this.STAT_API].response.data.data;
    },
    noClientSelected() {
      return null === this.selectedClient;
    },
    agenciesDropdownFilter() {
      if (this.selectedClient === null) return null;
      if (this.selectedClient.id === ClientListAllOption.id) return null;

      return [this.selectedClient.id];
    },
    /**
     * A wrapper around our filters so that we can have the ability to watch
     * all of these in a single watcher method rather than declaring one
     * watcher for each value.
     *
     * This computed value will will have keys that correspond to the filters
     * the API is expected.
     */
    watchedFilterBuilderValues() {
      return {
        client: null === this.selectedClient ? [] : [this.selectedClient.id],
        agency: this.selectedAgencies.flatMap((agency) => agency.id),
        status: this.selectedStatuses.flatMap((status) => status.id),
        campaignType: this.selectedOrderTypes.flatMap((type) => type.id),
        dateFrom: this.selectedDates.start,
        dateTo: this.selectedDates.end,
      };
    },
    // Metrics
    adImpressions() {
      return this.stats.adImpressions
        ? formatNumber(this.stats.adImpressions)
        : null;
    },
    adClicks() {
      return this.stats.adClicks ? formatNumber(this.stats.adClicks) : null;
    },
    ctr() {
      return this.stats.ctr ? `${this.stats.ctr}%` : null;
    },
    socialCtr() {
      return this.stats.socialCtr ? `${this.stats.socialCtr}%` : null;
    },
    socialEngagement() {
      return this.stats.socialEngagement
        ? formatNumber(this.stats.socialEngagement)
        : null;
    },
    soiView() {
      return this.stats.soiView ? formatNumber(this.stats.soiView) : null;
    },
    imageView() {
      return this.stats.imageView ? formatNumber(this.stats.imageView) : null;
    },
    videoView() {
      return this.stats.videoView ? formatNumber(this.stats.videoView) : null;
    },
    floorplanView() {
      return this.stats.floorplanView
        ? formatNumber(this.stats.floorplanView)
        : null;
    },
    websiteLiveChat() {
      return this.stats.websiteLiveChat
        ? formatNumber(this.stats.websiteLiveChat)
        : null;
    },
    inspectionAuctionLocationViews() {
      return this.stats.inspectionAuctionLocationViews
        ? formatNumber(this.stats.inspectionAuctionLocationViews)
        : null;
    },
    enquiryViaSocial() {
      return this.stats.enquiryViaSocial
        ? formatNumber(this.stats.enquiryViaSocial)
        : null;
    },
    enquiryViaForm() {
      return this.stats.enquiryViaForm
        ? formatNumber(this.stats.enquiryViaForm)
        : null;
    },
    enquiryViaPhone() {
      return this.stats.enquiryViaPhone
        ? formatNumber(this.stats.enquiryViaPhone)
        : null;
    },
    enquiryViaEmail() {
      return this.stats.enquiryViaEmail
        ? formatNumber(this.stats.enquiryViaEmail)
        : null;
    },
  },
  mounted() {
    this.handlePreselectedClient();
  },
};
</script>

<style lang="css">
.global-report-campaign-stats-section {
  display: grid;
  grid-template-columns: repeat(4, 1fr);
  grid-gap: 24px;
  }
</style>
